import script from "./PastProjects.vue?vue&type=script&setup=true&lang=ts"
export * from "./PastProjects.vue?vue&type=script&setup=true&lang=ts"

import "./PastProjects.vue?vue&type=style&index=0&id=41e00cd0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41e00cd0"]])

export default __exports__